import HighSchoolStudent from '../../../../shared/img/hs-student.svg';
import CommunityCollegeStudent from '../../../../shared/img/cc-student.svg';
import Educator from '../../../../shared/img/educator.svg';
import ParentOrGuardian from '../../../../shared/img/parent-guardian.svg';
import {ADULT_LEARNER} from '../utils';

export interface BasicSignUpProps {
  size: number;
  googleSignUp: () => void;
  setNavigationAnnouncement: (message: string) => void;
}

export const indefiniteArticle = (word: string) => {
  const vowels = ['a', 'e', 'i', 'o', 'u'];
  return vowels.includes(word[0].toLowerCase()) ? 'an' : 'a';
};

export const usertypeData = (userType: string, userSubtype?: string) => {
  const key = userSubtype && USER_MAP[userSubtype] ? userSubtype : userType;
  if (!USER_MAP[key]) {
    window.location.href = '/404';
    return undefined;
  }
  return USER_MAP[key];
};

export const USER_MAP = {
  'hs-student': {
    icon: HighSchoolStudent,
    text: 'High School Student',
  },
  'comm-college-student': {
    icon: CommunityCollegeStudent,
    text: 'College Transfer Student',
  },
  'cc-student': {
    icon: CommunityCollegeStudent,
    text: 'College Transfer Student',
  },
  teacher: {
    icon: Educator,
    text: 'Teacher',
  },
  counselor: {
    icon: Educator,
    text: 'Counselor',
  },
  mentor: {
    icon: Educator,
    text: 'Mentor',
  },
  communityCollegeStaff: {
    icon: Educator,
    text: 'Community College Staff Member',
  },
  parent: {
    icon: ParentOrGuardian,
    text: 'Parent or Guardian',
  },
  [ADULT_LEARNER]: {
    icon: CommunityCollegeStudent,
    text: 'Adult Learner',
  },
};
